<template>
  <section id="template-wizard" class="wizard-content">
    <sc-card class="wizard-content__card">
      <template slot="body">
        <billing-template-summary
          v-if="stepActive > 1"
          :logisticProviderId="formContent.lpAndDmInfo.logistic_provider_id"
          :templateName="formContent.name"
          :templateRowNumber="formContent.rowNumber"
        />

        <section class="wizard-content__steps">
          <new-billing-template-step-1 v-show="stepActive === 1" @onNextStep="nextStep" />
          <new-billing-template-step-2 v-show="stepActive === 2" @onNextStep="nextStep" @onPrevStep="prevStep" />
          <new-billing-template-step-3 v-show="stepActive === 3" @onNextStep="nextStep" @onPrevStep="prevStep"
                                       :previewMap="previewMap" :previewMapIsEmpty="previewMapIsEmpty"/>
        </section>

        <section class="wizard-content__loading">
          <new-billing-template-saving-modal
            @onOverwriteCancel="stepActive = 1"
            @onOverwriteConfirm="saveBillingTemplate({ ...formContent, overwrite: true })"/>
        </section>
      </template>
    </sc-card>
  </section>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { ScCard } from '@intelipost-js/secure-components';

import BillingTemplateSummary from './BillingTemplateSummary.vue';
import NewBillingTemplateStep1 from './NewBillingTemplateStep1.vue';
import NewBillingTemplateStep2 from './NewBillingTemplateStep2.vue';
import NewBillingTemplateStep3 from './NewBillingTemplateStep3.vue';
import NewBillingTemplateSavingModal from './NewBillingTemplateSavingModal.vue';

const { mapState, mapActions, mapMutations } = createNamespacedHelpers('recon/billing');

export default {
  name: 'ScNewBillingTemplateWizard',
  components: {
    ScCard,
    BillingTemplateSummary,
    NewBillingTemplateStep1,
    NewBillingTemplateStep2,
    NewBillingTemplateStep3,
    NewBillingTemplateSavingModal,
  },
  data() {
    return {
      stepActive: 1,
      formContent: {
        name: null,
        lpAndDmInfo: null,
        rowNumber: 1,
        previewFile: undefined,
        columns: {},
      },
      loadingLogisticProviders: false,
    };
  },
  computed: { ...mapState(['previewMap']) },
  methods: {
    ...mapActions(['previewBillingTemplate', 'saveBillingTemplate']),
    ...mapMutations(['setPreviewMap']),
    previewMapIsEmpty() {
      return Object.keys(this.previewMap).length === 0;
    },
    isFormCompleteForPreview() {
      return this.formContent &&
        this.formContent.previewFile &&
        this.formContent.rowNumber > 0;
    },
    nextStep(stepContent) {
      this.formContent = { ...this.formContent, ...stepContent };
      if (this.stepActive === 3) {
        if (this.previewMapIsEmpty() && this.isFormCompleteForPreview()) {
          this.previewBillingTemplate(this.formContent);
        } else if (!this.previewMapIsEmpty()) {
          this.saveBillingTemplate(this.formContent);
        }
      } else {
        this.stepActive += 1;
      }
    },
    prevStep() {
      if (this.stepActive === 3 && !this.previewMapIsEmpty()) {
        this.setPreviewMap({});
      } else {
        this.stepActive -= 1;
      }
    },
  },
};
</script>
<style lang="scss">
@import "~@intelipost-js/secure-ui/src/scss/variables"; //eslint-disable-line
#template-wizard {
  .wizard-content {

    &__card {
      border-radius: 8px;
    }

    &__steps {
      .upload-form {
        display: flex;
        justify-content: space-between;
        margin-left: -0.75em;
        margin-right: -0.75em;

        &__step {
          flex: 1;
          margin: 0.75em;

          &__label {
            color: $primary;

            .tag {
              color: #fff;
              background-color: $primary;
            }

            .additional-label {
              font-size: 14px;
              font-weight: 400;

              &:first-of-type {
                margin-top: 16px;
              }

              &:last-of-type {
                margin-bottom: 16px;
              }
            }
          }
        }
      }

      .continue-buttom {
        margin-top: 1.5em;
        display: flex;
        justify-content: flex-end;

        .button {
          font-weight: 700;

          &:last-child {
            margin-right: 0 !important;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/billing/pages/templates/components/NewBillingTemplateWizard.vue